// import axios from "axios";
// import { apiKey } from "./config";

function handleCSRF(axiosFunc) {
  // axios.get(`${apiKey}/sanctum/csrf-cookie`).then((response) => {
  //   // Extract the CSRF token from cookies
  //   const csrfToken = document.cookie
  //     .split("; ")
  //     .find((row) => row.startsWith("XSRF-TOKEN="))
  //     .split("=")[1];

  //   axiosFunc(csrfToken);
  // });
  axiosFunc();
}

export default handleCSRF;
